/*
 * Aviso de envio gratuito del carrito.
 *
 * 31-ago-2026: ademas de decir cuanto falta, propone el producto disponible MAS
 * BARATO que llega al umbral (excluyendo lo que ya esta en el carrito). La lista
 * de candidatos la sirve sections/ofm-gap-fillers.liquid y se pide una sola vez.
 * Si algo falla, se queda el aviso de siempre. Actuacion 2 del informe OFM-TDA-2608.
 */
if (typeof ShippingNotice != "function") {
  class ShippingNotice2 extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const freeShippingThreshold = Number(this.getAttribute("data-free-shipping")),
        freeShippingRemaining =
          Number(this.getAttribute("data-cart-total-amount")) -
          Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = "",
        shippingSuccess = !1;

      freeShippingRemaining < 0
        ? (shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
            "{{ remaining_amount }}",
            this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format)
          ))
        : ((shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free), (shippingSuccess = !0));

      this.hasAttribute("data-show-alert")
        ? (this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? "success" : "note"}">
            ${shippingMessage}
          </div>`)
        : (this.innerHTML = shippingMessage);

      if (!shippingSuccess) this._suggestGapFiller(Math.abs(freeShippingRemaining));
    }

    static _candidates() {
      if (!ShippingNotice2._cache) {
        ShippingNotice2._cache = fetch("/?section_id=ofm-gap-fillers")
          .then(function (r) {
            return r.text();
          })
          .then(function (t) {
            const el = new DOMParser().parseFromString(t, "text/html").getElementById("ofm-gap-fillers");
            return el ? JSON.parse(el.textContent) : [];
          })
          .catch(function () {
            return [];
          });
      }
      return ShippingNotice2._cache;
    }

    _suggestGapFiller(remaining) {
      const self = this;
      ShippingNotice2._candidates()
        .then(function (candidates) {
          if (!candidates || !candidates.length) return;

          const inCart = new Set(
            Array.from(document.querySelectorAll("[data-js-cart-item]")).map(function (el) {
              return String(el.dataset.productId);
            })
          );

          const pick = candidates
            .filter(function (c) {
              return c.p >= remaining && !inCart.has(String(c.id));
            })
            .sort(function (a, b) {
              return a.p - b.p;
            })[0];
          if (!pick) return;

          const wrap = document.createElement("div");
          wrap.className = "ofm-gap-suggestion text-size--small";
          wrap.style.marginTop = ".4em";

          const link = document.createElement("a");
          link.href = pick.u;
          link.className = "text-animation--underline-thin";
          const strong = document.createElement("strong");
          /* El tema capitaliza cada palabra de los <strong>: sin esto el nombre sale
             como «Botella Termica De Acero Inoxidable De Doble Capa». */
          strong.style.textTransform = "none";
          strong.textContent = pick.t;
          link.appendChild(strong);

          wrap.appendChild(document.createTextNode("Añade "));
          wrap.appendChild(link);
          wrap.appendChild(
            document.createTextNode(
              " (" + self._formatMoney(pick.p, KROWN.settings.shop_money_format) + ") y el envío te sale gratis."
            )
          );

          /* Dentro de la caja del aviso cuando la hay (pagina del carrito). Esa caja
             es flex: sin forzar linea entera, la sugerencia se pone de segunda
             columna y parte las dos frases en dos tiras estrechas. */
          const box = self.querySelector(".alert");
          if (box) {
            if (getComputedStyle(box).display.indexOf("flex") !== -1) box.style.flexWrap = "wrap";
            wrap.style.flexBasis = "100%";
            wrap.style.width = "100%";
            box.appendChild(wrap);
          } else {
            self.appendChild(wrap);
          }
        })
        .catch(function () {
          /* si algo falla, se queda el aviso de siempre */
        });
    }

    _formatMoney(cents, format) {
      typeof cents == "string" && (cents = cents.replace(".", ""));
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        if (((thousands = thousands || ","), (decimal = decimal || "."), isNaN(number) || number === null)) return 0;
        number = (number / 100).toFixed(precision);
        const parts = number.split("."),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  }
  typeof customElements.get("shipping-notice") > "u" && customElements.define("shipping-notice", ShippingNotice2);
}
